import {VIEWPORT_WIDTHS} from 'configs';
import {useViewport} from 'contexts/ViewportContext';
import React, {useState} from 'react';
import {Alert} from 'reactstrap';

import styles from './PageBestViewedAlert.module.scss';
import MuiIcon from 'components/Icons/MuiIcon';
import {useLocation} from 'react-router-dom';
import {isEqual} from 'lodash';

const PATH_VERIFY_CERTS_PAGE_DISCOUNTED =
  '/verify-certificates-subscription-offer';

function PageBestViewedAlert() {
  const {size} = useViewport();
  const {pathname} = useLocation();

  const isMobile = VIEWPORT_WIDTHS[size] < VIEWPORT_WIDTHS['lg'];
  const [isShown, setIsShown] = useState(true);
  const toggle = () => setIsShown(!isShown);

  if (!isMobile || !isEqual(pathname, PATH_VERIFY_CERTS_PAGE_DISCOUNTED))
    return null;

  return (
    <Alert className={styles['alert']} isOpen={isShown} toggle={toggle}>
      <div className={styles['alert--content']}>
        <MuiIcon name="star" className={styles['alert--content--icon']} />
        <p className="mb-0">
          For best experience, please view this website on a desktop
        </p>
      </div>
    </Alert>
  );
}

export default PageBestViewedAlert;
